<template>
  <div class="disponibility">
    {{ $t('fip.disponibility') }}
    <span
      v-for="(disponibility, index) in disponibilities"
      :key="index"
      class="item">
      {{ disponibility }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'FipDisponibility',
  props: {
    definitions: {
      type: Array,
      required: true
    }
  },
  computed: {
    disponibilities () {
      return this.definitions
        .map(definition => [definition.quality, definition.languageVersion])
        .reduce((a, b) => a.concat(b), []) // use .flat() when jenkins is node v14
        .filter((item, index, items) => items.indexOf(item) === index)
        .filter(item => item) // filter empty values
        .sort()
    }
  }
}
</script>

<style lang="scss"  scoped>
.disponibility {
  color: $black;
  max-width: 800px;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: normal;
  font-stretch: normal;
  font-weight: normal;
  margin-top: 24px;

  .item {
    display: inline-flex;
    margin-right: 5px;

    &:first-child {
      margin-left: 5px;
    }

    &:not(:last-child) {
      &:after {
        content: ',';
      }
    }
  }
}
</style>
